// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_KEY: "0541ec6e1c52b7c9b438a9c2cca850a0",
  firebaseConfig : {
    apiKey: "AIzaSyBriND4mCLSpi_tAnypLBVNgSXLlWQevgA",
    authDomain: "grupocentro-ab1e7.firebaseapp.com",
    databaseURL: "https://grupocentro-ab1e7.firebaseio.com",
    projectId: "grupocentro-ab1e7",
    storageBucket: "grupocentro-ab1e7.appspot.com",
    messagingSenderId: "821394397824",
    appId: "1:821394397824:web:b78094839d4fa1718ce465",
    measurementId: "G-5KLEL6275B"
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
